<template>
  <emd-modal
    has-header
    :open="open"
    @close="$emit('close')"
  >
    <template #header>
      <b>
        {{ $t('header') }}
      </b>
    </template>
    <template #content>
      <slot />
    </template>
  </emd-modal>
</template>

<script>
import { EmdModal } from 'emerald-vue/src/components'
export default {
  name: 'BoletoCancelModal',
  props: {
    open: Boolean
  },
  components: {
    EmdModal
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "header": "Solicitar estorno"
  },
  "en-US": {
    "header": "Refund boleto"
  }
}
</i18n>
